// extracted by mini-css-extract-plugin
module.exports = {"root":"ReportDetails_root__X1gP0","header":"ReportDetails_header__3XMTh","title":"ReportDetails_title__VkvwG","left":"ReportDetails_left__J7eFE"};